export enum TipiMezzi {
	Cartello = "Cartello",
	Freccia = "Freccia",
	Telo = "Telo",
	Cavalletto = "Cavalletto",
	Scritte = "Scritte",
	Tende = "Tende",
	Automezzo = "Automezzo",
	Postir_stazionario = "Postir stazionario",
	Pannello_luminoso_a_messaggio_variabile_o_intermittente = "Pannello luminoso a messaggio variabile o intermittente",
	Altro = "Altro",
}

export const ListaTipoMezzi: Array<TipiMezzi> = [
	TipiMezzi.Cartello,
	TipiMezzi.Freccia,
	TipiMezzi.Telo,
	TipiMezzi.Cavalletto,
	TipiMezzi.Scritte,
	TipiMezzi.Tende,
	TipiMezzi.Automezzo,
	TipiMezzi.Postir_stazionario,
	TipiMezzi.Pannello_luminoso_a_messaggio_variabile_o_intermittente,
	TipiMezzi.Altro,
];

export enum Facce {
	MONOFACCIALE = "Monofacciale",
	BIFACCIALE = "Bifacciale",
	POLIFACCIALE = "Polifacciale",
}
export enum Illuminazione {
	LUMINOSO = "Luminoso",
	OPACO = "Opaco",
}

export type MezzoPermanente =
	| MezzoPermanenteCartello
	| MezzoPermanenteFreccia
	| MezzoPermanenteTelo
	| MezzoPermanenteCavalletto
	| MezzoPermanenteScritte
	| MezzoPermanenteTende
	| MezzoPermanenteAuto
	| MezzoPermanentePostirStazionario
	| MezzoPermanenteAltro;

export type mezzoDaPosizione = {
	idMezzo: string;
	progMezzo: number;
	idTipoMezzo: string;
	descrTipoMezzo: string;
	quantita: number;
	messaggio: string;
	dataInstallazione: string;
	dataCessazione: string;
	dataCensimento: string;
	superficie: string;
	tipoInfrazione: string;
	imposta: string;
	ubicazione: string;
	strada: string;
	dimensione: string;
	flagBifacciale: string;
	flagLuminoso: string;
	flagInsegnaEsercizio: string;
};

export type FileMP = {
	Id: string;
	Title: string;
	url_documento: string;
	IsDeleted: boolean;
}
interface MezzoPermaneteBase {
	Id: string | null | undefined;
	IdMezzoDaPosizione: string | null | undefined;
	tipologia: string;
	dataInizioEsposizione: Date;
	dataFineEsposizione: Date;
	messaggioPubblicizzato: string;
	// foto: string; //TODO foto deve diventare DocumentoAllegato... ma che poi foto non è neanche in Mezzo permanente, è in lato.
	note: string;
	lati: Array<Lato>;
	filesAllegati: Array<FileMP> | [];
	mezzoDaPosizione: mezzoDaPosizione | null | undefined;
	isFlipped: boolean;
	showMezzo: null | undefined | boolean;
	cessato: null | undefined | boolean;
	dataCessazione: null | undefined | Date;
}

export type MezzoPermanenteCartello = MezzoPermaneteBase & {
	viaDiEsposizione: string;
	ubicazione: string;
	sedeDiEsecizio: boolean;
	lati: Array<Lato>;
	facce: Facce;

	//se monofacciale o bifacciale
	quantita: number;

	// effettuare controlli sulle dimensioni
	base: number | null; //in cm
	altezza: number | null; //in cm
	diametro: number | null; //in cm
	forma: string;

	//se polifacciale ???

	illuminazione: Illuminazione;
	autorizzazione: string;
	autorizzazioneRilasciataIl: string;
	// o dal al o anni
	autorizzazioneValidaDal: string;
	autorizzazioneValidaAl: string;
	anni: number;
};


export type MezzoPermanenteFreccia = MezzoPermanenteCartello;
export type MezzoPermanenteTelo = MezzoPermanenteCartello;
export type MezzoPermanenteCavalletto = MezzoPermanenteCartello;
export type MezzoPermanenteScritte = MezzoPermanenteCartello;
export type MezzoPermanenteTende = MezzoPermanenteCartello;
export type MezzoPermanentePostirStazionario = MezzoPermanenteCartello & {
	targa: string;
};

export type MezzoPermanenteAltro = MezzoPermaneteBase & {
	descrizioneMezzo: string;
	viaDiEsposizione: string;
	ubicazione: string;
	sedeDiEsecizio: boolean;
	lati: Array<Lato>;
	facce: Facce;

	//se monofacciale o bifacciale
	quantita: number;

	// effettuare controlli sulle dimensioni
	base: number | null; //in cm
	altezza: number | null; //in cm
	diametro: number | null; //in cm
	forma: string;

	//se polifacciale ???

	illuminazione: Illuminazione;
	autorizzazione: string;
	autorizzazioneRilasciataIl: string;
	// o dal al o anni
	autorizzazioneValidaDal: string;
	autorizzazioneValidaAl: string;
	anni: number;
};

import type { DocumentoAllegato } from '@/types/formRateizzazione';

export type Lato = {
	Id: string | null;
	Base__c: number | null;
	Diametro__c: number | null;
	Forma__c: string | null;
	Altezza__c: number | null;
	Messaggio_Pubblicizzato__c: string | null;
	docs: DocumentoAllegato | null;
};
export enum PortataVeicolo {
	INF30 = "Veicolo con portata utile inferiore a 30 Q.LI",
	SUP30 = "Veicolo con portata utile superiore a 30 Q.LI",
	Altro = "Veicolo non compreso nelle precedenti categorie",
}
export type MezzoPermanenteAuto = MezzoPermaneteBase & {
	targa: string;
	messaggioRiferitoAllAttivita: boolean;
	//se messaggioRiferitoAllAttivita == false
	tipoRapportoConIlSoggettoReclamizzato: string;

	portataVeicolo: PortataVeicolo;
	numeroLati: number;

	base: number; //in cm
	altezza: number; //in cm
	diametro: number; //in cm
};

export const TipiDocumento = {
	foto_bozzetti: "Foto Bozzetti",
	autorizzazione: "Autorizzazione",
	altri_documenti:
		"Altri Documenti (documenti che possono essere utili ai fini dell'accesso riduzioni/esenzioni)",
};

export type DichiarazioneMezziPermanenti0 = {
	Ente__c: string;
	idPosizione: string;
};

export type DichiarazioneMezziPermanenti1 = {
	Nome__c: string;
	Cognome__c: string;
	Cellulare__c: string;
	Codice_fiscale__c: string;
	Email__c: string;
	Pec__c: string | null;
	Ente__c: string;
	Nome_Ente__c: string;
	Stato_Dichiarazione__c: string;
	In_qualita_di__c: string | null;
	Descrizione_Rappresentato__c: string | null;
	Codice_Fiscale_Rappresentato__c: string | null;
	Nome_Rappresentato__c: string | null;
	Partita_Iva_Rappresentato__c: string | null;
	Via_Rappresentato__c: string | null;
	Civico_Sede_Rappresentato__c: string | null;
	Barrato_Rappresentato__c: string | null;
	Citta_Rappresentato__c: string | null;
	Provincia_Rappresentato__c: string | null;
	Cap_Rappresentato__c: string | null;
	Telefono_Rappresentato__c: string | null;
	Email_Rappresentato__c: string;
	Pec_Rappresentato__c: string;
	Tipo_Dichiarazione_Mezzo_Pubblicitario__c: string;
	filesAllegati: {}[] | null;
	Id: string;
};
